/**
 * Format helpers — kuruş → TL, tarih, yüzde, dakika.
 */

export function formatTRY(minor: number | null | undefined): string {
  if (minor == null) return "—";
  return new Intl.NumberFormat("tr-TR", {
    style: "currency", currency: "TRY",
  }).format(minor / 100);
}

export function formatPercent(value: number | null | undefined, digits = 1): string {
  if (value == null) return "—";
  return new Intl.NumberFormat("tr-TR", {
    style: "percent", minimumFractionDigits: digits,
    maximumFractionDigits: digits,
  }).format(value / 100);
}

export function formatDate(d: string | Date | null | undefined): string {
  if (!d) return "—";
  const date = typeof d === "string" ? new Date(d) : d;
  return new Intl.DateTimeFormat("tr-TR", {
    day: "2-digit", month: "2-digit", year: "numeric",
  }).format(date);
}

export function formatDateTime(d: string | Date | null | undefined): string {
  if (!d) return "—";
  const date = typeof d === "string" ? new Date(d) : d;
  return new Intl.DateTimeFormat("tr-TR", {
    day: "2-digit", month: "2-digit", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  }).format(date);
}

/**
 * Decimal stok miktarını okunabilir hale getir.
 *
 * Backend `DecimalField(decimal_places=3)` her zaman "XX.XXX" formatında
 * string döner. UI'da:
 *   - Fazla sıfırlar atılır ("5000.000" → "5000")
 *   - Ondalık ayracı TR locale virgül ("1.700" → "1,7")
 *   - Binlik ayraç KULLANILMAZ. Sebep: "1.7 kg domates" senaryosunda
 *     binlik ayraçlı "1.700" görünce kullanıcı bunu 1700 sanıyor.
 *     Stok miktarları (kg/adet/litre) günlük operasyonda dört haneli
 *     büyük sayıya nadiren çıkar; ayraçsız netlik daha değerli.
 *
 * Örnekler:
 *   "5000.000"  → "5000"      (tam sayı, ondalık yok)
 *   "-111.000"  → "-111"
 *   "1.700"     → "1,7"       (1 kg 700 gram)
 *   "0.125"     → "0,125"
 *   "5000.250"  → "5000,25"
 */
export function formatQty(q: string | number | null | undefined): string {
  if (q == null || q === "") return "—";
  const n = typeof q === "string" ? Number(q) : q;
  if (!Number.isFinite(n)) return String(q);
  if (Number.isInteger(n)) {
    // Tam sayı: ondalık ve binlik ayraç yok
    return String(n);
  }
  // Ondalıklı: virgülle göster, en fazla 3 hane, sondaki sıfırları at,
  // binlik ayracı kullanma (kafa karışıklığı önlenir).
  const fixed = n.toFixed(3).replace(/0+$/, "").replace(/\.$/, "");
  return fixed.replace(".", ",");
}

export function formatElapsed(seconds: number): string {
  if (seconds < 60) return `${seconds} sn`;
  const m = Math.floor(seconds / 60);
  const s = seconds % 60;
  if (m < 60) return `${m} dk ${s} sn`;
  const h = Math.floor(m / 60);
  return `${h} sa ${m % 60} dk`;
}
